import {
	EssityColumnProps,
	filterType,
} from '@components/shared/paginatedEssityTable/GridHelper';
import { AccountPharmacyUserDto } from '@services/src/models';

export const PortalAccountsTableColumn: EssityColumnProps<AccountPharmacyUserDto>[] = [
	{
		dataIndex: 'email',
		key: 'email',
		title: 'Email',
		sorter: true,
		filter: 'contains' as filterType,
	},
];
